import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import { EditIcon } from '../EnrollmentIconsSvg';
//import EditIcon from 'src/Admin/img/myProfile/EditIcon';
//import MasterPermissions from 'src/Member/api/MasterPermissions';
import './styles/contact-info.scss';

const getAddressLine = (address) => {
  return `${address?.Address1} ${address?.Address2 ? address?.Address2 : ''} ${
    address?.Address3 ? address?.Address3 : ''
  } ${address?.County ? address?.County : ''} ${
    address?.City ? address?.City : ''
  }, ${address?.State ? address?.State : ''}`;
};
const getAddressLineZip = (address) => {
  return `${address?.PostalCode} ${address?.Country} `;
};

const ContactInfo = ({
  residentialAddress,
  mailingAddress,
  PhoneEmailInfo,
  setShowEditMemberContactDetails,
  showUpdateBtn = true,
}) => {
  console.log('mailingAddress ::::: >>>>> ::::: ', mailingAddress);
  const { t } = useTranslation();
  const noValue = 'Not Specified';
  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }
  const residential_address =
    residentialAddress && residentialAddress
      ? getAddressLine(residentialAddress)
      : noValue;
  const residential_address_zip =
    residentialAddress && residentialAddress
      ? getAddressLineZip(residentialAddress)
      : '';

  const mailing_address =
    mailingAddress?.Address1 && mailingAddress?.Address1
      ? getAddressLine(mailingAddress)
      : noValue;
  const mailing_address_zip =
    mailingAddress?.Address1 && mailingAddress?.Address1
      ? getAddressLineZip(mailingAddress)
      : '';

  return (
    <>
      <div className="contact-info-section">
        <div className="top-header-container">
          <div className="title">
            {t('member.pages.my_profile.labels.contact_information')}
          </div>
          {showUpdateBtn && (
            <div>
              <GenericButton
                variant="secondary"
                className="btn-update-contact-info"
                onClick={() => {
                  setShowEditMemberContactDetails(true);
                }}
              >
                <EditIcon
                  fillColor={themeValuesObject['Secondary-1'] || '#1d90ba'}
                />{' '}
                UPDATE
              </GenericButton>
            </div>
          )}
        </div>
        <div className="pt-2 contact-container">
          <div className="first-column">
            <div>
              <label>{t('member.common_labels.email')}</label>
              <span className="plain-text ">
                {PhoneEmailInfo?.Email1 || noValue}
              </span>
            </div>
            <div>
              <label>{t('member.common_labels.alternate_email')}</label>
              <span className="plain-text ">
                {PhoneEmailInfo?.Email2 || noValue}
              </span>
            </div>
            <div>
              <label>{t('member.pages.my_profile.labels.home_phone')}</label>
              <span className="plain-text ">
                {PhoneEmailInfo?.HomePhone || noValue}
              </span>
            </div>
            <div>
              <label>{t('member.pages.my_profile.labels.work_phone')}</label>
              <span className="plain-text ">
                {PhoneEmailInfo?.WorkPhone || noValue}
              </span>
            </div>
          </div>

          <div className="second-column">
            <div>
              <label>{t('member.common_labels.residential_address')}</label>
              <span className="plain-text ">
                {residential_address}
                <br />
                {residential_address_zip}
              </span>
            </div>
            <div>
              <label>{t('member.common_labels.mailing_address')}</label>
              <span className="plain-text ">
                {mailingAddress ? mailing_address : null}
                <br />
                {mailingAddress && mailing_address_zip}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactInfo;
